<template>
	<div class="container">
		<div class="main">
			<div class="name-time">
				<div class="name">{{trainName}}</div>
				<div class="time">{{trainTime}}</div>
			</div>
			<div class="congratulation" v-if="trainNum">
				<img src="../assets/bian/meditation-finish.png" alt="" class="congratulation-icn">
				<div class="congratulation-text">恭喜！这是您完成的第{{trainNum}}次练习</div>
			</div>
			<div v-else style="height: 15px;"></div>
			<div class="chart-box">
				<div id="chart" v-if="emotionData.length!=0 && coverTime"></div>
				<div class="no-data" v-else>暂无数据</div>
			</div>
			<div class="time-box">
				<div class="meditation-time">
					<div class="time-main">
						<div class="time-title">练习时间</div>
						<div class="time-content">{{formatTime(trainStart)}}~{{formatTime(trainEnd)}}</div>
					</div>
				</div>
				<div class="keep-time">
					<div class="time-main">
						<div class="time-title">持续时长</div>
						<div class="time-content">{{trainMin}}<span>分</span>{{trainSec}}<span>秒</span></div>
					</div>
				</div>
			</div>
			<div class="index-box">
				<div class="index-title t-a">心情状态</div>
				<div class="contrast-box">
					<div class="contrast-main">
						<div class="pre">
							<div class="pre-title">练习前</div>
							<div class="pre-num" v-if="emotionData.length!=0">
								{{emotionPreMean}}<span>{{textFilter('emotion',emotionPreMean)}}</span></div>
							<div class="no-index" v-else>暂无数据</div>
						</div>
						<div class="next">
							<div class="next-title">练习后</div>
							<div class="next-num" v-if="emotionData.length!=0&&coverTime">
								{{emotionNextMean}}<span>{{textFilter('emotion',emotionNextMean)}}</span></div>
							<div class="no-index" v-if="emotionData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&emotionData.length!=0">时间过短</div>
						</div>
						<div class="contrast">
							<div class="contrast-title">变化率</div>
							<div class="contrast-num" v-if="emotionData.length!=0&&coverTime"><span
									v-if="emotionNextMean>=emotionPreMean">+</span><span
									v-if="emotionNextMean<emotionPreMean">-</span>{{contrastEmotion}}%</div>
							<div class="no-index" v-if="emotionData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&emotionData.length!=0">时间过短</div>
						</div>
						<img src="../assets/bian/increase.png" alt="" class="increase"
							v-if="emotionNextMean>emotionPreMean&&coverTime">
						<img src="../assets/bian/reduce.png" alt="" class="reduce"
							v-if="emotionNextMean<emotionPreMean&&coverTime">
					</div>
				</div>
			</div>
			<div class="index-box">
				<div class="index-title t-b">疲劳状态</div>
				<div class="contrast-box">
					<div class="contrast-main">
						<div class="pre">
							<div class="pre-title">练习前</div>
							<div class="pre-num" v-if="tiredData.length!=0">
								{{tiredPreMean}}<span>{{textFilter('tired',tiredPreMean)}}</span></div>
							<div class="no-index" v-else>暂无数据</div>
						</div>
						<div class="next">
							<div class="next-title">练习后</div>
							<div class="next-num" v-if="tiredData.length!=0&&coverTime">
								{{tiredNextMean}}<span>{{textFilter('tired',tiredNextMean)}}</span></div>
							<div class="no-index" v-if="tiredData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&tiredData.length!=0">时间过短</div>
						</div>
						<div class="contrast">
							<div class="contrast-title">变化率</div>
							<div class="contrast-num" v-if="tiredData.length!=0&&coverTime"><span
									v-if="tiredNextMean>=tiredPreMean">+</span><span
									v-if="tiredNextMean<tiredPreMean">-</span>{{contrastTired}}%</div>
							<div class="no-index" v-if="tiredData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&tiredData.length!=0">时间过短</div>
						</div>
						<img src="../assets/bian/increase.png" alt="" class="increase"
							v-if="tiredNextMean>tiredPreMean&&coverTime">
						<img src="../assets/bian/reduce.png" alt="" class="reduce"
							v-if="tiredNextMean<tiredPreMean&&coverTime">
					</div>
				</div>
			</div>
			<div class="index-box">
				<div class="index-title t-c">压力状态</div>
				<div class="contrast-box">
					<div class="contrast-main">
						<div class="pre">
							<div class="pre-title">练习前</div>
							<div class="pre-num" v-if="stressData.length!=0">
								{{stressPreMean}}<span>{{textFilter('stress',stressPreMean)}}</span></div>
							<div class="no-index" v-else>暂无数据</div>
						</div>
						<div class="next">
							<div class="next-title">练习后</div>
							<div class="next-num" v-if="stressData.length!=0&&coverTime">
								{{stressNextMean}}<span>{{textFilter('stress',stressNextMean)}}</span></div>
							<div class="no-index" v-if="stressData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&stressData.length!=0">时间过短</div>
						</div>
						<div class="contrast">
							<div class="contrast-title">变化率</div>
							<div class="contrast-num" v-if="stressData.length!=0&&coverTime"><span
									v-if="stressNextMean>=stressPreMean">+</span><span
									v-if="stressNextMean<stressPreMean">-</span>{{contrastStress}}%</div>
							<div class="no-index" v-if="stressData.length==0">暂无数据</div>
							<div class="no-cover" v-if="!coverTime&&stressData.length!=0">时间过短</div>
						</div>
						<img src="../assets/bian/increase.png" alt="" class="increase"
							v-if="stressNextMean>stressPreMean&&coverTime">
						<img src="../assets/bian/reduce.png" alt="" class="reduce"
							v-if="stressNextMean<stressPreMean&&coverTime">
					</div>
				</div>
			</div>
			<div class="back" @click="toServece()">返回</div>
		</div>
	</div>
</template>
<script>
	import {
		train_ln,
		train_info
	} from '../api/adjust'
	import {
		train_report
	} from '../api/server'
	import moment from 'moment'
	export default {
		data() {
			return {
				loginPhone: '',
				trainNum: '',
				trainName: '',
				trainTime: '',
				trainStart: '',
				trainEnd: '',
				trainMin: '',
				trainSec: '',
				chart: null,
				timeList: [],
				chartStartTime: '',
				chartEndTime: '',
				emotionData: [],
				stressData: [],
				tiredData: [],
				emotionPreMean: '',
				emotionNextMean: '',
				stressPreMean: '',
				stressNextMean: '',
				tiredPreMean: '',
				tiredNextMean: '',
				contrastEmotion: '',
				contrastStress: '',
				contrastTired: '',
				coverTime: false,
				imei: '',
				markAreaData:[]
			};
		},
		computed: {},
		methods: {
			toServece() {
				this.$router.push('/my')
			},
			formatTime(time) {
				return moment(time * 1000).format('HH:mm')
			},
			trainLn() {
				train_ln(this.loginPhone).then(res => {
					if (res.status == 200) {
						this.trainNum = res.data.train_num
					}
				})
			},
			trainInfo() {
				train_info(this.$route.query.id).then(res => {
					if (res.status == 200) {
						let trainData = res.data.trainData[0]
						this.trainName = trainData.name;
						this.trainTime = moment(trainData.end_time * 1000).format('YYYY-MM-DD HH:mm');
						this.trainEnd = trainData.end_time;
						this.trainStart = trainData.start_time;
						this.trainMin = parseInt((this.trainEnd - this.trainStart) / 60)
						this.trainSec = parseInt((this.trainEnd - this.trainStart) % 60)
						let trainStartNum = trainData.start_time*1000;
						let trainEndNum = trainData.end_time*1000;
						train_report(trainData.imei, trainData.start_time, trainData.end_time).then(res => {
							if (res.status == 200) {
								
								if(!res.data.data.length){
									return;
								}
								let emotionData = res.data.emotionData;
								let stressData = res.data.stressData;
								let tiredData = res.data.tiredData;
								this.chartStartTime = res.data.startTime;
								this.chartEndTime = res.data.endTime;
								let nowTime = parseInt(moment().valueOf())
								if (nowTime > this.chartEndTime) {
									this.coverTime = true;
								}
								let startTime = moment(res.data.startTime).valueOf();
								let emotionList = [];
								let stressList = [];
								let tiredList = [];
								for (let i = 0; i < 60; i++) {
									let m = moment(startTime).add(i, 'minutes').minute();
									if (m < 10) {
										m = '0' + m
									} else {
										m = m + ''
									}
									this.timeList.push(m)
									emotionList.push({
										minute: m,
										index: null
									})
									stressList.push({
										minute: m,
										index: null
									})
									tiredList.push({
										minute: m,
										index: null
									})
								}
								for (let item of emotionList) {
									for (let t of emotionData) {
										let m = moment(t.time_str).minute();
										if (m == item.minute) {
											item.index = t.emotion_index;
										}
									}
								}
								for (let item of stressList) {
									for (let t of stressData) {
										let m = moment(t.time_str).minute();
										if (m == item.minute) {
											item.index = t.stress_index;
										}
									}
								}
								for (let item of tiredList) {
									for (let t of tiredData) {
										let m = moment(t.time_str).minute();
										if (m == item.minute) {
											item.index = t.tired_index;
										}
									}
								}
								// for (let item of emotionList) {
								// 	this.emotionData.push(item.index)
								// }
								// for (let item of stressList) {
								// 	this.stressData.push(item.index)
								// }
								// for (let item of tiredList) {
								// 	this.tiredData.push(item.index)
								// }
								this.timeList = [];

								let stressPre = [];
								let stressNext = [];
								let stressMid = [];
								let emotionPre = [];
								let emotionMid = [];
								let emotionNext = [];
								let tiredPre = [];
								let tiredMid = [];
								let tiredNext = [];
								let splitLine = [];
								for (let i in res.data.data) {
									let item = res.data.data[i];
									this.timeList.push(item.date_str.slice(-5))
									
									this.emotionData.push(item.emotion)
									this.tiredData.push(item.tired)
									this.stressData.push(item.stress)
									
									if (item.date_time < trainStartNum) {
										emotionPre.push(item)
										stressPre.push(item)
										tiredPre.push(item)
									}
									if (item.date_time > trainEndNum) {
										emotionNext.push(item)
										stressNext.push(item)
										tiredNext.push(item)
									}
									if (item.date_time >= trainStartNum&& item.date_time <= trainEndNum) {
										emotionMid.push(item)
										stressMid.push(item)
										tiredMid.push(item)
										splitLine.push(item.date_str.slice(-5))
									}
								}
								let trainStart = '';
								let trainEnd = '';
								
								if(emotionPre.length){
									trainStart = emotionPre[emotionPre.length - 1].date_str.slice(-5);
									trainEnd = emotionPre[emotionPre.length - 1].date_str.slice(-5);
								}
								// if(emotionNext.length){
								// 	trainEnd = emotionNext[0].date_str.slice(-5);
								// }
								if(emotionMid.length){
									trainStart = emotionMid[0].date_str.slice(-5);
									trainEnd = emotionMid[emotionMid.length - 1].date_str.slice(-5);
								}
								let preline = [{
											name: '练习前',
											xAxis: this.timeList[0],
											itemStyle: {
												// color: 'rgba(255,255,219,0.4)',
												color: 'rgba(254,248,239,0.4)'
											}
										},
										{
											xAxis: trainStart,
											itemStyle: {
												color: 'rgba(254,248,239,0.4)'
											}
										}
									];
								let endline = [{
											name: '练习后',
											xAxis: trainEnd,
											itemStyle: {
												// color: 'rgba(254,248,239,0.4)',
												color: 'rgba(255,255,219,0.4)'
											}
										},
										{
											xAxis: this.timeList[this.timeList.length - 1],
											itemStyle: {
												// color: 'rgba(254,248,239,0.4)',
												color: 'rgba(255,255,219,0.4)'
											}
										}
									];
								let midline = [{
											name: '练习中',
											xAxis: trainStart,
											itemStyle: {
												color: 'rgba(237,237,255,0.4)'
											}
										},
										{
											xAxis: trainEnd,
											itemStyle: {
												color: 'rgba(237,237,255,0.4)'
											}
										}
									];
								if(emotionPre.length&&emotionMid.length&&emotionNext.length){
									this.markAreaData = [preline,midline,endline]
								}else if(!emotionNext.length){
									this.markAreaData = [preline,endline];
									// for(let k = 0;k<5;k++){
									// 	this.emotionData.push(null)
									// 	this.tiredData.push(null)
									// 	this.stressData.push(null)
									// }
								}else{
									this.markAreaData = [preline,endline]
								}
								// if(emotionPre.length&&emotionNext.length){
								// 	this.markAreaData = [preline,endline]
								// }
								
								// this.markAreaData = [
								// 	[{
								// 			name: '练习前2',
								// 			xAxis: this.timeList[0],
								// 			itemStyle: {
								// 				color: 'rgba(255,255,219,0.4)'
								// 			}
								// 		},
								// 		{
								// 			xAxis: trainStart,
								// 			itemStyle: {
								// 				color: 'rgba(255,255,219,0.4)'
								// 			}
								// 		}
								// 	],
								// 	[{
								// 			name: '练习中2',
								// 			xAxis: trainStart,
								// 			itemStyle: {
								// 				color: 'rgba(237,237,255,0.4)'
								// 			}
								// 		},
								// 		{
								// 			xAxis: trainEnd,
								// 			itemStyle: {
								// 				color: 'rgba(237,237,255,0.4)'
								// 			}
								// 		}
								// 	],
								// 	[{
								// 			name: '练习后',
								// 			xAxis: trainEnd,
								// 			itemStyle: {
								// 				color: 'rgba(254,248,239,0.4)'
								// 			}
								// 		},
								// 		{
								// 			xAxis: this.timeList[this.timeList.length - 1],
								// 			itemStyle: {
								// 				color: 'rgba(254,248,239,0.4)'
								// 			}
								// 		}
								// 	]
								// ]
								let emotionPreAll = 0;
								let emotionNextAll = 0;
								for (let item of emotionPre) {
									emotionPreAll += item.emotion;
								}
								for (let item of emotionNext) {
									emotionNextAll += item.emotion;
								}
								let emotionPreMean = parseInt(emotionPreAll / emotionPre.length)
								let emotionNextMean = parseInt(emotionNextAll / emotionNext.length)
								this.emotionPreMean = emotionPreMean;
								this.emotionNextMean = emotionNextMean;
								if (emotionNextMean >= emotionPreMean) {
									let dif = (emotionNextMean / emotionPreMean - 1) * 100
									this.contrastEmotion = parseInt(dif)
								}
								if (emotionNextMean < emotionPreMean) {
									let dif = (1 - emotionNextMean / emotionPreMean) * 100
									this.contrastEmotion = parseInt(dif)
								}
								this.$nextTick(() => {
									this.reportChart()
								})
								let stressPreAll = 0;
								let stressNextAll = 0;
								for (let item of stressPre) {
									stressPreAll += item.stress;
								}
								for (let item of stressNext) {
									stressNextAll += item.stress;
								}
								let stressPreMean = parseInt(stressPreAll / stressPre.length)
								let stressNextMean = parseInt(stressNextAll / stressNext.length)
								this.stressPreMean = stressPreMean;
								this.stressNextMean = stressNextMean;
								if (stressNextMean >= stressPreMean) {
									let dif = (stressNextMean / stressPreMean - 1) * 100
									this.contrastStress = parseInt(dif)
								}
								if (stressNextMean < stressPreMean) {
									let dif = (1 - stressNextMean / stressPreMean) * 100
									this.contrastStress = parseInt(dif)
								}
								let tiredPreAll = 0;
								let tiredNextAll = 0;
								for (let item of tiredPre) {
									tiredPreAll += item.tired;
								}
								for (let item of tiredNext) {
									tiredNextAll += item.tired;
								}
								let tiredPreMean = parseInt(tiredPreAll / tiredPre.length)
								let tiredNextMean = parseInt(tiredNextAll / tiredNext.length)
								this.tiredPreMean = tiredPreMean;
								this.tiredNextMean = tiredNextMean;
								if (tiredNextMean >= tiredPreMean) {
									let dif = (tiredNextMean / tiredPreMean - 1) * 100
									this.contrastTired = parseInt(dif)
								}
								if (tiredNextMean < tiredPreMean) {
									let dif = (1 - tiredNextMean / tiredPreMean) * 100
									this.contrastTired = parseInt(dif)
								}
							}
							if (res.status == 400) {
								this.$toast('暂无数据,请上传');
							}
						})
					}
				})
			},
			reportChart() {
				let trainStart = moment(this.trainStart).minute();
				if (trainStart < 10) {
					trainStart = '0' + trainStart
				} else {
					trainStart = trainStart + ''
				}
				let trainEnd = moment(this.trainEnd).minute();
				if (trainEnd < 10) {
					trainEnd = '0' + trainEnd
				} else {
					trainEnd = trainEnd + ''
				}
				let dom = document.getElementById('chart');
				this.chart = this.$echarts.init(dom);
				let option = {
					color: ['#5f5fff', '#F59A23', '#8D13FF'],
					legend: {
						itemHeight: 8,
						itemWidth: 16,
						left: 'center',
						bottom: 20,
						data: [{
								icon: 'roundRect',
								name: '情绪指数'
							},
							{
								icon: 'roundRect',
								name: '压力指数'
							},
							{
								icon: 'roundRect',
								name: '疲劳指数'
							},
						]
					},
					grid: {
						left: '13%',
						right: '14%',
						bottom: '20%',
						top: '13%',
					},
					xAxis: {
						type: 'category',
						data: this.timeList,
						boundaryGap: false,
						splitLine: {
							show: true
						}
					},
					yAxis: {
						type: 'value',
						max: 100,

					},
					series: [{
							name: '情绪指数',
							type: 'line',
							symbol: 'none',
							smooth: true,
							lineStyle: {
								color: '#0000FF'
							},
							data:this.emotionData,                        
							markArea: {
								data: this.markAreaData
							}
						},
						{
							name: '压力指数',
							type: 'line',
							symbol: 'none',
							smooth: true,
							lineStyle: {
								color: '#F59A23'
							},
							data: this.stressData,
							// markArea: {
							// 	data: [
							// 		[{
							// 				name: '练习前',
							// 				xAxis: this.timeList[0],
							// 				itemStyle: {
							// 					color: 'rgba(255,255,219,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: trainStart,
							// 				itemStyle: {
							// 					color: 'rgba(255,255,219,0.4)'
							// 				}
							// 			}
							// 		],
							// 		[{
							// 				name: '练习中',
							// 				xAxis: trainStart,
							// 				itemStyle: {
							// 					color: 'rgba(237,237,255,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: trainEnd,
							// 				itemStyle: {
							// 					color: 'rgba(237,237,255,0.4)'
							// 				}
							// 			}
							// 		],
							// 		[{
							// 				name: '练习后',
							// 				xAxis: trainEnd,
							// 				itemStyle: {
							// 					color: 'rgba(254,248,239,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: this.timeList[this.timeList.length - 1],
							// 				itemStyle: {
							// 					color: 'rgba(254,248,239,0.4)'
							// 				}
							// 			}
							// 		]
							// 	]
							// }
						},
						{
							name: '疲劳指数',
							type: 'line',
							symbol: 'none',
							smooth: true,
							lineStyle: {
								color: '#8D13FF'
							},
							data: this.tiredData,
							// markArea: {
							// 	data: [
							// 		[{
							// 				name: '练习前',
							// 				xAxis: this.timeList[0],
							// 				itemStyle: {
							// 					color: 'rgba(255,255,219,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: trainStart,
							// 				itemStyle: {
							// 					color: 'rgba(255,255,219,0.4)'
							// 				}
							// 			}
							// 		],
							// 		[{
							// 				name: '练习中',
							// 				xAxis: trainStart,
							// 				itemStyle: {
							// 					color: 'rgba(237,237,255,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: trainEnd,
							// 				itemStyle: {
							// 					color: 'rgba(237,237,255,0.4)'
							// 				}
							// 			}
							// 		],
							// 		[{
							// 				name: '练习后',
							// 				xAxis: trainEnd,
							// 				itemStyle: {
							// 					color: 'rgba(254,248,239,0.4)'
							// 				}
							// 			},
							// 			{
							// 				xAxis: this.timeList[this.timeList.length - 1],
							// 				itemStyle: {
							// 					color: 'rgba(254,248,239,0.4)'
							// 				}
							// 			}
							// 		]
							// 	]
							// }
						},
					]
				};
				this.chart.setOption(option);
			},
			textFilter(type, num) {
				if (type == 'emotion') {
					if (num <= 49) {
						return '较差'
					}
					if (num >= 50 && num <= 69) {
						return '一般'
					}
					if (num >= 70 && num <= 100) {
						return '愉悦'
					}
				}
				if (type == 'tired') {
					if (num <= 49) {
						return '精力充沛'
					}
					if (num >= 50 && num <= 69) {
						return '有点疲惫'
					}
					if (num >= 70 && num <= 100) {
						return '十分疲惫'
					}
				}
				if (type == 'stress') {
					if (num <= 49) {
						return '放松'
					}
					if (num >= 50 && num <= 69) {
						return '稍有压力'
					}
					if (num >= 70 && num <= 100) {
						return '压力较大'
					}
				}

			},
		},
		created() {
			let phone = localStorage.getItem('phone');
			this.loginPhone = phone;
			if(this.$route.query.newTrain) this.trainLn();
		},
		mounted() {
			this.trainInfo();
		}
	};
</script>
<style lang='less' scoped>
	.container {
		min-height: 100vh;
		background-image: linear-gradient(to bottom, #E9FAF5, #F4FFF8);
	}

	.main {
		padding: 16px;
	}

	.name-time {
		display: flex;
		justify-content: space-between;
	}

	.name {
		height: 30px;
		line-height: 30px;
		font-size: 20px;
		color: #2E2E2E;
		font-weight: bold;
	}

	.time {
		height: 30px;
		line-height: 30px;
		color: #2E2E2E;
		font-size: 14px;
		font-weight: 500;
	}

	.congratulation {
		margin-top: 10px;
		padding: 12px 16px;
		display: flex;
		justify-content: flex-start;
		border-radius: 16px;
		background-color: #fff;
		margin-bottom: 14px;
	}

	.congratulation-icn {
		height: 32px;
	}

	.congratulation-text {
		height: 32px;
		line-height: 32px;
		font-size: 15px;
		color: #2E2E2E;
		font-weight: 500;
		margin-left: 10px;
	}

	.chart-box {
		background-color: #fff;
		border-radius: 16px;
		height: 300px;
		margin-bottom: 14px;
	}

	#chart {
		height: 100%;
		width: 100%;
	}

	.no-data {
		height: 300px;
		line-height: 300px;
		text-align: center;
		background-color: rgba(114, 112, 112, 0.5);
		border-radius: 15px;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
	}

	.time-box {
		display: flex;
		justify-content: space-between;
		margin-bottom: 14px;
	}

	.meditation-time,
	.keep-time {
		background-color: #fff;
		border-radius: 16px;
		width: 48%;
	}

	.time-main {
		padding: 20px 16px;
	}

	.time-title {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		font-weight: 500;
		color: #2E2E2E;
	}

	.time-content {
		height: 24px;
		line-height: 24px;
		padding-top: 8px;
		font-size: 20px;
		font-weight: bold;
		color: #2E2E2E;
	}

	.time-content span {
		font-size: 12px;
		font-weight: 500;
		margin: 0px 5px;
	}

	.index-box {
		background-color: #fff;
		padding: 16px;
		border-radius: 16px;
		margin-bottom: 14px;
	}

	.t-a {
		color: #0000FF;
	}

	.t-b {
		color: #8D13FF;
	}

	.t-c {
		color: #F59A23;
	}

	.index-title {
		height: 20px;
		line-height: 20px;
		font-size: 16px;
		font-weight: bolder;
		padding-bottom: 16px;
	}

	.contrast-box {
		background-color: #f5f5f5;
		padding: 10px 12px;
		border-radius: 6px;
	}

	.contrast-main {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.pre,
	.next {
		width: 30%;
	}

	.pre-title,
	.next-title {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #606060;
		font-weight: 500;
	}

	.pre-num,
	.next-num {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		font-size: 20px;
		color: #2E2E2E;
	}

	.no-index {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		font-size: 12px;
		color: #969696;
	}

	.no-cover {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		font-size: 16px;
		color: #2E2E2E;
	}

	.pre-num span,
	.next-num span {
		font-size: 12px;
		color: #969696;
		margin-left: 4px;
	}

	.contrast {
		width: 25%;
	}

	.contrast-title {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #606060;
		font-weight: 500;
	}

	.contrast-num {
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		font-size: 20px;
		color: #2E2E2E;
	}

	.increase,
	.reduce {
		width: 12%;
	}

	.back {
		height: 52px;
		border-radius: 26px;
		background-image: linear-gradient(to right, #00C8BD, #40D2DA);
		text-align: center;
		line-height: 52px;
		color: #fff;
		font-size: 16px;
		font-weight: 500;
	}
</style>